import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, EmbeddedVideo, FormProps, KeepProportions } from '@gik/ui';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { IBaseFeaturesFormValues } from '@gik/create/components/FeatureStep/FeatureStep';
import DonationsContainer from '@gik/create/components/DonationsContainer/DonationsContainer';
import { DonationsValues, useCreateFlowStore } from '@gik/create';
import { CreatePageContext } from '@gik/create/components/CreatePage/CreatePage';
import { CreateAnalyticsEvents } from '@gik/create/hooks/useCreateAnalytics';
import noop from '@gik/core/utils/noop';
import { FeatureDonationsInputNames } from '@gik/create/enums/FeatureDonationsInputNames';

export interface ICreateFeaturesDonationsAsideFormValues extends IBaseFeaturesFormValues {
  [FeatureDonationsInputNames.DonationsValues]: DonationsValues;
}

export interface IDonationsAsideProps extends FormProps {
  onChange?: (values: ICreateFeaturesDonationsAsideFormValues) => void;
  featureVideo: string;
  trackDonationsVideoPlayed: () => void;
}

const blockName = 'donations-aside';

export default function DonationsAside({
  onChange = noop,
  featureVideo,
  trackDonationsVideoPlayed,
}: IDonationsAsideProps) {
  const bem = bemBlock(blockName);
  const formValues = useCreateFlowStore(state => state.formValues);
  const { handleNext } = React.useContext(CreatePageContext);

  function handleChange(value: DonationsValues) {
    onChange({
      [FeatureDonationsInputNames.DonationsValues]: value,
    });
  }

  return (
    <div className={bem()}>
      <DonationsContainer
        asForm
        trackingId={CreateAnalyticsEvents.CREATE_STARTED}
        direction={'vertical'}
        value={formValues[FeatureDonationsInputNames.DonationsValues]}
        onChange={handleChange}
        variant="create"
      />

      <div className={bem('button-container')}>
        <Button variant="default" size="sm" onClick={handleNext} pill>
          {i18n.t(translationKeys.FundraisingSkip)}
        </Button>
        <p className={bem('skip-description')}>{i18n.t(translationKeys.FundraisingSkipDescription)}</p>
      </div>

      <KeepProportions className={bem('video')}>
        <EmbeddedVideo
          url={`https://www.youtube.com/watch?v=${featureVideo}`}
          lightboxOverlay
          lightboxTitle={i18n.t(translationKeys.FundraisingTitle)}
          trackFunction={trackDonationsVideoPlayed}
        />
      </KeepProportions>
    </div>
  );
}
